import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface ItemDto {
	id: string;
	worldId: string;
	itemTypeId?: string | null;
	itemTypeName?: string | null;
	sourcePoiId?: string | null;
	sourcePoiName?: string | null;
	sourceRegionName?: string | null;
	name: string;
	category?: string | null;
	description?: string | null;
	rarity?: string | null;
	gmNotes?: string | null;
	tags: string[];
	imageAssetId?: string | null;
	foundryId?: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface ItemsListResponse {
	items: ItemDto[];
	total: number;
}

export interface ItemGetResponse {
	item: ItemDto;
}

export interface UpsertItemRequest {
	name: string;
	itemTypeId?: string | null;
	sourcePoiId?: string | null;
	category?: string | null;
	description?: string | null;
	rarity?: string | null;
	gmNotes?: string | null;
	tags?: string[] | null;
	imageAssetId?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ItemsService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, args?: { q?: string; itemTypeId?: string; sourcePoiId?: string }): Observable<ItemsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (args?.q) params = params.set('q', args.q);
		if (args?.itemTypeId) params = params.set('itemTypeId', args.itemTypeId);
		if (args?.sourcePoiId) params = params.set('sourcePoiId', args.sourcePoiId);
		return this.http.get<ItemsListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/items`, { params });
	}

	get(worldId: string, itemId: string): Observable<ItemGetResponse> {
		return this.http.get<ItemGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/items/${itemId}`);
	}

	create(worldId: string, request: UpsertItemRequest): Observable<ItemGetResponse> {
		return this.http.post<ItemGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/items`, {
			Name: request.name,
			ItemTypeId: request.itemTypeId ?? null,
			SourcePoiId: request.sourcePoiId ?? null,
			Category: request.category ?? null,
			Description: request.description ?? null,
			Rarity: request.rarity ?? null,
			GmNotes: request.gmNotes ?? null,
			Tags: request.tags ?? [],
			ImageAssetId: request.imageAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, itemId: string, request: UpsertItemRequest): Observable<ItemGetResponse> {
		return this.http.put<ItemGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/items/${itemId}`, {
			Name: request.name,
			ItemTypeId: request.itemTypeId ?? null,
			SourcePoiId: request.sourcePoiId ?? null,
			Category: request.category ?? null,
			Description: request.description ?? null,
			Rarity: request.rarity ?? null,
			GmNotes: request.gmNotes ?? null,
			Tags: request.tags ?? [],
			ImageAssetId: request.imageAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, itemId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/items/${itemId}`);
	}
}
